import React, { useState } from 'react';

import { IFormFieldInputBaseProps } from '@components/form-fields';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Collapse, IconButton } from '@mui/material';
import { MAIN_THEME } from '@styles';

import EnhancedButton from '../_old/EnhancedButton';

import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

interface ICollapsavleSectionProps extends IFormFieldInputBaseProps {
  open?: boolean;
  className?: string;
  classes?: { header?: string; content?: string };
  children?: React.ReactNode;
  actions?: JSX.Element;
  onButtonClick?: () => void;
  count?: number;
}

const useStyles = makeStyles()(() => ({
  container: {
    width: '100%',
    fontFamily: `${MAIN_THEME.font.bold} !important`,
    fontSize: `${MAIN_THEME.fontSize.md} !important`,
    border: `2px solid ${MAIN_THEME.color.lightGray}`,
    borderRadius: '15px',
  },
  header: {
    cursor: 'pointer',
    fontSize: `${MAIN_THEME.fontSize.md} !important`,
    lineHeight: '27px',
    color: MAIN_THEME.color.black47,
    '&:hover': {
      color: 'black'
    },
    '&:focus': {
      border: 'none',
      outline: 'none'
    },
    background: 'unset',
    border: 'none',
    width: '5000px'
  },
  content: {
    padding: '0px 12px 12px 44px'
  },
  collapse: {
    transform: 'rotate(0deg)',
    transition: '150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  },
  collapseOpen: {
    transform: 'rotate(180deg)'
  },
  actions: {
    width: '20%',
    height: '50px',
    textAlign: 'center',
    backgroundColor: 'black',
    color: 'white'
  }
}));

const CollapsibleSection: React.FC<ICollapsavleSectionProps> = ({
  title,
  open,
  className,
  classes = {},
  children,
  actions,
  onButtonClick,
  count
}) => {
  const { classes: collapsableClasses } = useStyles();
  const [collapse, setCollapse] = useState(!!open);

  function toggleCollapse() {
    setCollapse(!collapse);
  }

  return (
    <div className={collapsableClasses.container}>
      <div
        role="presentation"
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: '10px 10px 0px 10px'
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >
          <div>
            {count ? (
              <span
                style={{
                  width: '30px',
                  height: '30px',
                  backgroundColor: 'rgb(248, 206, 204)',
                  textAlign: 'center',
                  borderRadius: '8px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'rgb(253, 40, 56)',
                  marginRight: '8px'
                }}
              >
                {count}
              </span>
            ) : undefined}
            {title}
          </div>

          <IconButton
            aria-label={'Show More'}
            className={clsx(collapsableClasses.collapse, {
              [collapsableClasses.collapseOpen]: collapse
            })}
            onClick={toggleCollapse}
          >
            <ExpandMoreIcon />
          </IconButton>
        </div>
        {actions && (
          <EnhancedButton
            type="button"
            backgroundColor={MAIN_THEME.color.black}
            color={'white'}
            onClick={onButtonClick}
          >
            {'Modify'}
          </EnhancedButton>
        )}
      </div>
      <Collapse
        in={collapse}
        timeout={150}
        className={clsx(collapsableClasses.content, classes.content)}
        style={{ paddingLeft: 10 }}
        classes={
          className
            ? {
                wrapperInner: className
              }
            : {}
        }
      >
        {children}
      </Collapse>
    </div>
  );
};

export default CollapsibleSection;
